
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pdp/example",
      function () {
        return require("private-next-pages/pdp/example.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pdp/example"])
      });
    }
  